module.exports = __webpack_public_path__ + "img/202305251324229444z2.4132bc9f.jpg";